import { api } from "./axios.config";
import axios from "./axios";
import React, { useContext } from "react";
import { PAYMENT_GATEWAY_TYPE } from "../reusable/common";

const API_URL = api.apiUrl;
const EVENT_URL = "/event/";

export const getPaymentMethodDetails = async (eventId) => {
    const PAYMENT_METHOD = "/payment/methods";
    return axios.get(API_URL + EVENT_URL + eventId + PAYMENT_METHOD);
};

export const getEventPlan = async (eventId, event_plan, pgMethod = 6,) => {
    const QUERY = `?pg_method=${pgMethod}&event_plan=${event_plan}`;
    return axios.get(`${API_URL + EVENT_URL + eventId}/subscribe-event${QUERY}`);
};

export const addPaymentGateway = (eventId, publicKey, secretKey, pgType, merchant_id) => {
    const PAYMENT_GATEWAY_URL = `${API_URL}${EVENT_URL}${eventId}/payment-gateway`;
    let payload;
    if (pgType == PAYMENT_GATEWAY_TYPE.AREEBA) {
        payload = {
            public_key: merchant_id,           // Merchant ID is the public key for Areeba
            secret_key: publicKey,             // Public key here refers to API password
            pg_type: pgType,
            secondary_secret_key: secretKey    // Reporting API password
        };
    } else {
        payload = {
            public_key: publicKey,
            secret_key: secretKey,
            pg_type: pgType,

        };
    }


    return axios.post(PAYMENT_GATEWAY_URL, payload);
};

export const addCopperXPaymentGateway = (eventId, pgType, secretKey) => {
    const PAYMENT_GATEWAY_URL = `${API_URL}${EVENT_URL}${eventId}/payment-gateway`;
    const payload = {
        pg_type: pgType,
        secret_key: secretKey,
    };
    return axios.post(PAYMENT_GATEWAY_URL, payload);
};

export const disconnectPaymentGateway = (eventId, pgType) => {
    return axios.delete(`${API_URL}${EVENT_URL}${eventId}/payment-gateway`, {
        params: { pg_type: pgType }
    });
};

export const getPaymentGateways = (eventId) => {
    return axios.get(`${API_URL}${EVENT_URL}${eventId}/payment-gateway`);
};

export const validatePaymentGateway = (eventId, pgType, secretKey, publicKey, merchant_id) => {
    let params;

    if (pgType === PAYMENT_GATEWAY_TYPE.AREEBA) {
        params = {
            public_key: merchant_id,           // Merchant ID is the public key for Areeba
            secret_key: publicKey,             // Public key here refers to API password
            pg_type: pgType,
            secondary_secret_key: secretKey    // Reporting API password
        };
    } else {
        params = {
            public_key: publicKey,
            secret_key: secretKey,
            pg_type: pgType
        };
    }


    if (
        publicKey !== undefined &&
        publicKey !== null &&
        publicKey !== '') {
        params.public_key = PAYMENT_GATEWAY_TYPE.AREEBA === pgType ? merchant_id : publicKey;
    }


    return axios.get(`${API_URL}${EVENT_URL}${eventId}/payment-gateway/validate`, {
        params
    });
};


export const updateStripeWebhook = (eventId) => {
    return axios.put(`${API_URL}${EVENT_URL}${eventId}/payment-gateway/stripe/webhooks`)

};
